import React from 'react';
import Icon from '../../../components/AppIcon';

const StaffRankingTable = ({ data }) => {
  const getRankBadge = (rank) => {
    if (rank === 1) return { icon: 'Trophy', color: 'text-warning', bg: 'bg-warning/10' };
    if (rank === 2) return { icon: 'Medal', color: 'text-muted-foreground', bg: 'bg-muted' };
    if (rank === 3) return { icon: 'Award', color: 'text-accent', bg: 'bg-accent/10' };
    return { icon: 'Circle', color: 'text-muted-foreground', bg: 'bg-muted' };
  };

  const getPerformanceColor = (score) => {
    if (score >= 90) return 'text-success';
    if (score >= 80) return 'text-primary';
    if (score >= 70) return 'text-warning';
    return 'text-error';
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-heading font-semibold text-foreground mb-2">
            Staff Performance Rankings
          </h2>
          <p className="text-sm text-muted-foreground">
            Comparative performance metrics and improvement trends
          </p>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Rank</th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Staff Member</th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Role</th>
              <th className="text-center py-3 px-4 text-sm font-semibold text-foreground">Performance Score</th>
              <th className="text-center py-3 px-4 text-sm font-semibold text-foreground">Check-ins</th>
              <th className="text-center py-3 px-4 text-sm font-semibold text-foreground">Member Rating</th>
              <th className="text-center py-3 px-4 text-sm font-semibold text-foreground">Tasks Completed</th>
              <th className="text-center py-3 px-4 text-sm font-semibold text-foreground">Improvement</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((staff) => {
              const badge = getRankBadge(staff?.rank);
              return (
                <tr key={staff?.rank} className="border-b border-border hover:bg-muted/50 transition-colors duration-250">
                  <td className="py-4 px-4">
                    <div className={`w-10 h-10 rounded-lg ${badge?.bg} flex items-center justify-center`}>
                      <Icon name={badge?.icon} size={20} className={badge?.color} />
                    </div>
                  </td>
                  <td className="py-4 px-4">
                    <div className="flex items-center gap-3">
                      <img
                        src={staff?.avatar}
                        alt={staff?.avatarAlt}
                        className="w-10 h-10 rounded-full object-cover"
                      />
                      <span className="text-sm font-medium text-foreground">{staff?.name}</span>
                    </div>
                  </td>
                  <td className="py-4 px-4">
                    <span className="text-sm text-muted-foreground">{staff?.role}</span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span className={`text-sm font-semibold data-text ${getPerformanceColor(staff?.performanceScore)}`}>
                      {staff?.performanceScore}%
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span className="text-sm text-foreground data-text">
                      {staff?.checkIns > 0 ? staff?.checkIns?.toLocaleString() : 'N/A'}
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <div className="flex items-center justify-center gap-1">
                      <Icon name="Star" size={14} color="var(--color-warning)" />
                      <span className="text-sm font-medium text-foreground data-text">{staff?.memberRating}</span>
                    </div>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span className="text-sm text-foreground data-text">{staff?.tasksCompleted}</span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <div className="flex items-center justify-center gap-1">
                      <Icon name="TrendingUp" size={14} color="var(--color-success)" />
                      <span className="text-sm font-semibold text-success">{staff?.improvement}</span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StaffRankingTable;